"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var UserInfoConverter_1 = require("../../user/conversions/UserInfoConverter");

var ExportedPromotionForecast_1 = require("../model/ExportedPromotionForecast");

var ExportedPromotionForecastConverter_1 = require("./ExportedPromotionForecastConverter");
/**
 * Default implementation of {@link ExportedPromotionForecastConverter}.
 *
 * @author VRu
 */


var ExportedPromotionForecastConverterImpl =
/*#__PURE__*/
function (_ExportedPromotionFor) {
  _inherits(ExportedPromotionForecastConverterImpl, _ExportedPromotionFor);

  function ExportedPromotionForecastConverterImpl(userInfoConverter) {
    var _this;

    _classCallCheck(this, ExportedPromotionForecastConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExportedPromotionForecastConverterImpl).call(this));
    _this.userInfoConverter = userInfoConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ExportedPromotionForecastConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new ExportedPromotionForecast_1.ExportedPromotionForecast(ExportedPromotionForecast_1.ExportedPromotionForecast.schema.id.valueOf(conversions.documentToClassId(source)), ExportedPromotionForecast_1.ExportedPromotionForecast.schema.entityId.valueOf(conversions.toClassReferenceId(source.entityId)), ExportedPromotionForecast_1.ExportedPromotionForecast.schema.preExportId.valueOf(conversions.toClassReferenceId(source.preExportId)), ExportedPromotionForecast_1.ExportedPromotionForecast.schema.state.valueOfField(source), ExportedPromotionForecast_1.ExportedPromotionForecast.schema.created.valueOfField(source), this.userInfoConverter.toObject(source.createdBy, conversions), ExportedPromotionForecast_1.ExportedPromotionForecast.schema.lastModified.valueOfField(source), ExportedPromotionForecast_1.ExportedPromotionForecast.schema.nextAttempt.valueOfField(source), ExportedPromotionForecast_1.ExportedPromotionForecast.schema.attemptCount.valueOfField(source), ExportedPromotionForecast_1.ExportedPromotionForecast.schema.requestId.valueOfField(source), ExportedPromotionForecast_1.ExportedPromotionForecast.schema.error.valueOfField(source), ExportedPromotionForecast_1.ExportedPromotionForecast.schema.processId.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        entityId: conversions.toDocumentReferenceId(source.entityId)
      });
      Object.assign(result, {
        preExportId: conversions.toDocumentReferenceId(source.preExportId)
      });
      Object.assign(result, {
        state: source.state
      });
      Object.assign(result, {
        created: conversions.fromDate(source.created)
      });
      Object.assign(result, {
        createdBy: this.userInfoConverter.toDocument(source.createdBy, conversions)
      });
      Object.assign(result, {
        lastModified: conversions.fromDate(source.lastModified)
      });
      Object.assign(result, {
        nextAttempt: conversions.fromDate(source.nextAttempt)
      });
      Object.assign(result, {
        attemptCount: source.attemptCount
      });
      Object.assign(result, {
        requestId: source.requestId
      });
      Object.assign(result, {
        error: source.error
      });
      Object.assign(result, {
        processId: source.processId
      });
      return result;
    }
  }]);

  return ExportedPromotionForecastConverterImpl;
}(ExportedPromotionForecastConverter_1.ExportedPromotionForecastConverter);

ExportedPromotionForecastConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [UserInfoConverter_1.UserInfoConverter])], ExportedPromotionForecastConverterImpl);
exports.ExportedPromotionForecastConverterImpl = ExportedPromotionForecastConverterImpl;